import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const ERROR_TRACKING_SCHEMA = Object.freeze({});
const RECORD = generateSchema(ERROR_TRACKING_SCHEMA);
const KEYS: any = generateKeys(ERROR_TRACKING_SCHEMA);

export class ErrorTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.error;
  }

  get properties() {
    return this.toJS();
  }
}
